import React from 'react';
import { CustomerData } from '../firebase/types';

interface CompanyStatusIconProps {
  status?: CustomerData['status'];
  size?: 'sm' | 'md' | 'lg';
}

const CompanyStatusIcon: React.FC<CompanyStatusIconProps> = ({
  status = 'uncontracted',
  size = 'md',
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case 'uncontracted':
        return {
          label: '未契約',
          bgColor: 'bg-white',
          textColor: 'text-black',
          borderColor: 'border-gray-300',
        };
      case 'new':
        return {
          label: '新規',
          bgColor: 'bg-gray-300',
          textColor: 'text-black',
          borderColor: 'border-gray-400',
        };
      case 'existing':
        return {
          label: '既存',
          bgColor: 'bg-gray-700',
          textColor: 'text-white',
          borderColor: 'border-gray-800',
        };
      case 'revived':
        return {
          label: '復活',
          bgColor: 'bg-black',
          textColor: 'text-white',
          borderColor: 'border-black',
        };
      default:
        return {
          label: '未契約',
          bgColor: 'bg-white',
          textColor: 'text-black',
          borderColor: 'border-gray-300',
        };
    }
  };

  const getSizeClasses = () => {
    switch (size) {
      case 'sm':
        return 'px-2 py-0.5 text-xs';
      case 'md':
        return 'px-2.5 py-1 text-sm';
      case 'lg':
        return 'px-3 py-1.5 text-base';
      default:
        return 'px-2.5 py-1 text-sm';
    }
  };

  const config = getStatusConfig();
  const sizeClasses = getSizeClasses();

  return (
    <span
      className={`inline-flex items-center justify-center rounded-md border ${config.bgColor} ${config.textColor} ${config.borderColor} ${sizeClasses} font-medium`}
      title={config.label}
    >
      {config.label}
    </span>
  );
};

export default CompanyStatusIcon;
